import { getBackendHost } from '../utils/backendHost';

export async function googleAuthRequest(path, { method = 'POST', body, authenticated = false } = {}) {
  const headers = { 'Content-Type': 'application/json' };
  if (authenticated) headers.Authorization = `Bearer ${localStorage.getItem('jwt_authorization') || ''}`;
  const response = await fetch(`${getBackendHost()}/auth/${path}`, {
    method, headers, body: body === undefined ? undefined : JSON.stringify(body), cache: 'no-store',
  });
  const result = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(result?.error?.message || (path.startsWith('account-deletion') ? 'Your deletion request could not be completed. Please try again.' : 'Google sign-in is unavailable. Please try again.'));
  return result;
}

export async function beginGoogleChallenge(purpose) {
  const bytes = crypto.getRandomValues(new Uint8Array(32));
  const proof = Array.from(bytes, value => value.toString(16).padStart(2, '0')).join('');
  const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(proof));
  const proofHash = Array.from(new Uint8Array(digest), value => value.toString(16).padStart(2, '0')).join('');
  const challenge = await googleAuthRequest('google/challenge', {
    body: { purpose, proofHash }, authenticated: ['link', 'password', 'delete'].includes(purpose),
  });
  return { ...challenge, proof };
}
